import { logger } from "server/lib/logger";
import { findByContractAndTokenId } from "server/services/assets";

import Render, { Props } from "client/components/pages/Asset/Render";
import { GetServerSideProps } from "next";
import MetadataHead from "@/client/components/common/MetdataHead";
import {
  generateProjectDatabaseIdFromTokenID,
  getGraphQlClient,
} from "@/shared/artblocks";
import { graphql } from "@/gql/index";

const getProjectDocument = graphql(/* GraphQL */ `
  query GetProject($id: String!) {
    projects_metadata_by_pk(id: $id) {
      id
      render_delay
    }
  }
`);

export const getServerSideProps: GetServerSideProps = async (context) => {
  const contract = context.query.contract as string;
  const tokenId = context.query.tokenId as string;

  if (
    !contract ||
    !tokenId ||
    contract === "undefined" ||
    contract === "null" ||
    tokenId === "undefined" ||
    tokenId === "null"
  ) {
    return {
      notFound: true,
    };
  }

  const fetchProjectData = async () => {
    const id = generateProjectDatabaseIdFromTokenID(contract, tokenId);

    const graphqlClient = getGraphQlClient();
    const res = await graphqlClient.request(getProjectDocument, {
      id: id,
    });

    return res.projects_metadata_by_pk;
  };

  try {
    const asset = await findByContractAndTokenId(contract, tokenId);
    if (!asset) {
      return {
        notFound: true,
      };
    }

    let projectRes;
    try {
      projectRes = await fetchProjectData();
    } catch (error) {
      logger.error(error, "Error fetching project data");
    }

    const metadata: MetadataHead = {};
    if (asset?.name) metadata.title = asset?.name + " - Sansa";
    if (asset?.imageThumbnailUrl) metadata.imageUrl = asset?.imageThumbnailUrl;
    metadata.useFallbackDescription = false; // no description for assets

    const props: Props = {
      asset: asset ? JSON.parse(JSON.stringify(asset)) : null,
      renderDelay: projectRes?.render_delay || 0,
    };

    return {
      props,
    };
  } catch (err) {
    logger.error(err, "failed to fetch asset in getServerSideProps");
    throw err;
  }
};

export default Render;
